import React from "react";

class MobileFooter extends React.Component {
  render() {
    return (
      <>
        <div
          // className={"fullWidth"}
          style={{
            height: "fit-content",
            overflow: "hidden",
            paddingLeft: "0",
            paddingRight: "0",
            fontSize: "12px",
            alignContent: "center",
            textAlign: "center",
            alignItems: "stretch",
            backgroundColor: "rgb(2,0,36)",
            display: "flex",
            flexDirection: "column"
          }}
        >
          <h4 style={{ color: "white", fontWeight: "bold" }}>Machine Learning Practices</h4>
          <a href="\contact" style={{ color: "white", width: "100%",fontStyle:"italic", fontSize: "15px", paddingBottom:"5px" , paddingTop:"5px"}}>Contact</a>
          <a href="\aboutme" style={{ color: "white", width: "100%",fontStyle:"italic", fontSize: "15px", paddingBottom:"5px", paddingTop:"5px" }}>About me</a>
          <p style={{ color: "white", width: "100%",fontStyle:"italic", fontSize: "15px", paddingBottom:"5px", paddingTop:"5px" }}>Email: htanloc994@gmail.com</p>
          {/* <div
            className="container"
            style={{
              color: "white",
              bottom: "0",
              height: "fit-content",
              width: "100%",
              alignItems: "center",
              alignContent: "stretch",
              textAlign: "center",
              fontSize: "14px",
              margin: "5px",
              display: "flex",
              flexDirection: "column"
            }}
          >
            <h4 style={{ color: "white", fontWeight: "bold" }}>Topics</h4>
            <a style={{ color: "white", width: "100%",fontStyle:"italic", fontSize: "15px", paddingBottom:"5px", paddingTop:"5px" }} href="\nlp">Natural Language Processing</a>
            <a style={{ color: "white", width: "100%",fontStyle:"italic", fontSize: "15px", paddingBottom:"5px", paddingTop:"5px" }} href="\cv">Computer Vision</a>
          </div> */}
          <div
            className="container"
            style={{
              color: "white",
              bottom: "0",
              height: "fit-content",
              width: "100%",
              alignItems: "center",
              alignContent: "stretch",
              textAlign: "center",
              fontSize: "14px",
              margin: "5px",
              display: "flex",
              flexDirection: "column"
            }}
          >
            <a className="footer-section" href="/privacy" style={{ color: "white", width: "100%",fontStyle:"italic", fontSize: "15px", paddingBottom:"5px" }} >Privacy</a>
            <a style={{ color: "white", width: "100%",fontStyle:"italic", fontSize: "15px", paddingBottom:"5px", paddingTop:"5px" }} className="footer-section" href="/disclaimer">Disclaimer</a>
            <a style={{ color: "white", width: "100%",fontStyle:"italic", fontSize: "15px", paddingBottom:"5px", paddingTop:"5px" }} className="footer-section" href="/terms">Terms</a>
            <a style={{ color: "white", width: "100%",fontStyle:"italic", fontSize: "15px", paddingBottom:"5px", paddingTop:"5px" }} className="footer-section" href="/service">Contact</a></div>
          <div
            className="container"
            style={{
              color: "white",
              bottom: "0",
              height: "fit-content",
              backgroundColor: "white",
              width: "100%",
              alignItems: "center",
              alignContent: "left",
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "14px",
            }}
          >
            <a className="footer-section" href="/privacy">LinkedIn </a>
            <a className="footer-section" href="/disclaimer">Twitter </a>
            <a className="footer-section" href="/terms">Facebook </a>
            <a className="footer-section" href="/terms">Newsletter </a>
            <a className="footer-section" href="/terms">RSS</a>
          </div>
          <p style={{ color: "white", fontWeight: "bold", marginTop: "10px", marginBottom: "10px", fontSize:"12px", paddingBottom:"5px" }}>Copyright © 2023 Machine Learning Practices</p>
        </div>
      </>
    )
  }
}

export default MobileFooter;
